
import { init as loglevel_init } from "./loglevel/index"
import modernizr_onLoad from "./modernizr/onLoad"
import rails_ujs from "./rails-ujs"
import timeago from "./jquery-timeago"

const onLoad = () => {
  loglevel_init()
  modernizr_onLoad()
  rails_ujs.init()
  timeago.onLoad()
}

export default onLoad
